import componentRegistry from '../registry.js';

// See also js-layerSwitcher and js-strateTabs
// Ses implementation https://adrianroselli.com/2013/02/aria-tabs.html
export default class Tabs {
  /** @type {HTMLElement} */
  el;
  /** @type {HTMLCollection} */
  #tabs;
  /** @type {HTMLCollection} */
  #panels;

  constructor({ el }) {
    this.el = el;
    this.el.addEventListener('click', this.#handleTabClick);
    this.#tabs = this.el.getElementsByClassName('js-tab');
    this.#panels = this.el.getElementsByClassName('js-tabpanel');
  }

  #handleTabClick = (event) => {
    const tab = event.target.closest('.js-tab');
    if (!tab) return;

    const panelID = tab.getAttribute('aria-controls')?.trim().split(/\s+/)[0];
    const panels = Array.from(this.#panels);
    const panel = panelID != null ? panels.find(({ id }) => id === panelID) : null;

    if (!panel) return;

    event.preventDefault();
    for (const t of this.#tabs) t.setAttribute('aria-selected', t === tab);
    for (const p of panels) p.setAttribute('aria-hidden', p !== panel);
  };
}

componentRegistry.define('js-tabs', Tabs);
